/* =========================================================
   PDP image lightbox + zoom (Cymbiotika-style)
   Click a gallery image -> full-screen overlay with one centred
   image + close button. Click the image to step zoom
   (1x -> 2.5x -> 4x -> 1x) toward the click point. Drag to pan
   while zoomed. Desktop also: scroll to zoom. Mobile: pinch to
   zoom, drag to pan. Images only; no prev/next. Loaded only when
   the PDP image_zoom setting is "lightbox".
   ========================================================= */
(function () {
  var scope = document.querySelector('.mpg');
  if (!scope || document.querySelector('.pdpz')) return;

  var ZOOM_LEVELS = [1, 2.5, 4];
  var MIN = 1, MAX = 4;

  var ov = document.createElement('div');
  ov.className = 'pdpz';
  ov.hidden = true;
  ov.innerHTML =
    '<button class="pdpz__close" type="button" aria-label="Close">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" xmlns="http://www.w3.org/2000/svg"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
    '</button>' +
    '<div class="pdpz__stage" data-pdpz-stage>' +
      '<span class="pdpz__loader" data-pdpz-loader aria-hidden="true"></span>' +
      '<img class="pdpz__img" alt="" draggable="false">' +
    '</div>';
  document.body.appendChild(ov);

  var stage = ov.querySelector('[data-pdpz-stage]');
  var img = ov.querySelector('.pdpz__img');
  var loader = ov.querySelector('[data-pdpz-loader]');
  var closeBtn = ov.querySelector('.pdpz__close');

  var scale = 1, tx = 0, ty = 0;

  function apply() {
    img.style.transform = 'translate(' + tx.toFixed(1) + 'px,' + ty.toFixed(1) + 'px) scale(' + scale.toFixed(3) + ')';
    img.classList.toggle('is-zoomed', scale > 1);
  }
  function maxPan() {
    var r = stage.getBoundingClientRect();
    return {
      x: Math.max(0, (img.clientWidth * scale - r.width) / 2),
      y: Math.max(0, (img.clientHeight * scale - r.height) / 2)
    };
  }
  function clampPan() {
    var m = maxPan();
    tx = Math.min(m.x, Math.max(-m.x, tx));
    ty = Math.min(m.y, Math.max(-m.y, ty));
  }
  function reset() { scale = 1; tx = 0; ty = 0; apply(); }

  function open(src, placeholder) {
    reset();
    ov.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    // next frame so the transition from the hidden state runs
    requestAnimationFrame(function () { ov.classList.add('is-open'); });
    // instant placeholder (already-loaded on-page image) while hi-res decodes
    loader.hidden = false;
    if (placeholder) { img.src = placeholder; }
    var hi = new Image();
    hi.onload = function () { img.src = hi.src; loader.hidden = true; };
    hi.onerror = function () { loader.hidden = true; if (!img.src) img.src = src; };
    hi.src = src;
  }
  function close() {
    document.documentElement.style.overflow = '';
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      ov.classList.remove('is-open');
      ov.hidden = true;
      img.src = '';
      return;
    }
    ov.classList.remove('is-open'); // plays the exit transition
    var finished = false;
    function done() {
      if (finished) return;
      finished = true;
      ov.hidden = true;
      img.src = '';
      ov.removeEventListener('transitionend', onEnd);
    }
    function onEnd(e) { if (e.target === ov && e.propertyName === 'opacity') done(); }
    ov.addEventListener('transitionend', onEnd);
    setTimeout(done, 400); // fallback if transitionend doesn't fire
  }

  /* Open on gallery image click (images only; skip video/model) */
  scope.addEventListener('click', function (e) {
    var item = e.target.closest('[data-zoom-src]');
    if (!item || !scope.contains(item)) return;
    if (item.classList.contains('product__media-item--full')) return;
    var src = item.getAttribute('data-zoom-src');
    if (!src) return;
    e.preventDefault();
    e.stopPropagation();
    var onPage = item.querySelector('img');
    open(src, onPage ? onPage.currentSrc || onPage.src : null);
  }, true);

  closeBtn.addEventListener('click', close);
  ov.addEventListener('click', function (e) { if (e.target === ov) close(); });
  document.addEventListener('keydown', function (e) { if (!ov.hidden && e.key === 'Escape') close(); });

  /* Zoom toward a point (px, py within the stage, 0..1) */
  function zoomToLevel(nextScale, px, py) {
    var r = stage.getBoundingClientRect();
    var prev = scale;
    scale = Math.min(MAX, Math.max(MIN, nextScale));
    if (scale === 1) { tx = 0; ty = 0; apply(); return; }
    // keep the clicked point roughly stationary
    var offX = (px - 0.5) * r.width;
    var offY = (py - 0.5) * r.height;
    var ratio = scale / prev;
    tx = tx * ratio - offX * (ratio - 1);
    ty = ty * ratio - offY * (ratio - 1);
    clampPan();
    apply();
  }

  /* Click image -> step through zoom levels toward the click */
  var dragMoved = false;
  img.addEventListener('click', function (e) {
    if (dragMoved) { dragMoved = false; return; } // ignore click that ended a drag
    var r = stage.getBoundingClientRect();
    var px = (e.clientX - r.left) / r.width;
    var py = (e.clientY - r.top) / r.height;
    var i = ZOOM_LEVELS.indexOf(scale);
    var next = ZOOM_LEVELS[(i + 1) % ZOOM_LEVELS.length];
    if (i === -1) next = ZOOM_LEVELS[1];
    zoomToLevel(next, px, py);
  });

  /* Desktop: wheel zoom toward cursor */
  stage.addEventListener('wheel', function (e) {
    e.preventDefault();
    var r = stage.getBoundingClientRect();
    var px = (e.clientX - r.left) / r.width;
    var py = (e.clientY - r.top) / r.height;
    zoomToLevel(scale + (-e.deltaY) * 0.0018 * scale, px, py);
  }, { passive: false });

  /* Drag to pan (mouse) */
  var dragging = false, sx = 0, sy = 0, stx = 0, sty = 0;
  img.addEventListener('mousedown', function (e) {
    if (scale <= 1) return;
    dragging = true; dragMoved = false;
    sx = e.clientX; sy = e.clientY; stx = tx; sty = ty;
    img.classList.add('is-grabbing');
    e.preventDefault();
  });
  window.addEventListener('mousemove', function (e) {
    if (!dragging) return;
    tx = stx + (e.clientX - sx);
    ty = sty + (e.clientY - sy);
    if (Math.abs(e.clientX - sx) > 3 || Math.abs(e.clientY - sy) > 3) dragMoved = true;
    clampPan(); apply();
  });
  window.addEventListener('mouseup', function () {
    if (!dragging) return;
    dragging = false;
    img.classList.remove('is-grabbing');
  });

  /* Mobile: pinch to zoom, drag to pan, double-tap to step zoom */
  var mode = null, startDist = 0, startScale = 1, tsx = 0, tsy = 0, ttx = 0, tty = 0, lastTap = 0;
  function dist(t) { var dx = t[0].clientX - t[1].clientX, dy = t[0].clientY - t[1].clientY; return Math.hypot(dx, dy); }

  stage.addEventListener('touchstart', function (e) {
    if (e.touches.length === 2) {
      mode = 'pinch'; startDist = dist(e.touches); startScale = scale;
    } else if (e.touches.length === 1) {
      var now = Date.now();
      if (now - lastTap < 300) {
        var r = stage.getBoundingClientRect();
        var px = (e.touches[0].clientX - r.left) / r.width;
        var py = (e.touches[0].clientY - r.top) / r.height;
        var i = ZOOM_LEVELS.indexOf(scale);
        zoomToLevel(ZOOM_LEVELS[(i + 1) % ZOOM_LEVELS.length] || ZOOM_LEVELS[1], px, py);
        lastTap = 0;
        return;
      }
      lastTap = now;
      if (scale > 1) { mode = 'pan'; tsx = e.touches[0].clientX; tsy = e.touches[0].clientY; ttx = tx; tty = ty; }
    }
  }, { passive: false });

  stage.addEventListener('touchmove', function (e) {
    if (mode === 'pinch' && e.touches.length === 2) {
      e.preventDefault();
      scale = Math.min(MAX, Math.max(MIN, startScale * (dist(e.touches) / startDist)));
      if (scale === 1) { tx = 0; ty = 0; }
      clampPan(); apply();
    } else if (mode === 'pan' && e.touches.length === 1) {
      e.preventDefault();
      tx = ttx + (e.touches[0].clientX - tsx);
      ty = tty + (e.touches[0].clientY - tsy);
      clampPan(); apply();
    }
  }, { passive: false });

  stage.addEventListener('touchend', function (e) { if (e.touches.length === 0) mode = null; });
})();
